import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { MaterialIssue, MaterialIssueCreate, MaterialIssueFilter } from '../data/materialIssue';

export function createMaterialIssueService(client: AxiosInstance) {
  return createCrudService<MaterialIssue, MaterialIssueCreate, MaterialIssueFilter>(
    client,
    '/manufacturing/MaterialIssue',
    'id',
  );
}

export type MaterialIssueService = CrudService<MaterialIssue, MaterialIssueCreate, MaterialIssueFilter>;
